import { Box, keyframes } from "@mui/material";
import { useSelector } from "react-redux";
import { selectFileUploadOrDeleteAPITriggerActive } from "../../Store";
import { TriggerTypeAPI } from "./FileAttachments";

const flow = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

export default function FileUploadOrDeleteProgressBar() {
    const fileUploadOrDeleteAPITriggerActive = useSelector(selectFileUploadOrDeleteAPITriggerActive);
    return (
        <Box
            sx={{
                width: "90%",
                height: "4px",
                borderRadius: "2px",
                overflow: "hidden",
                background:
                    fileUploadOrDeleteAPITriggerActive.triggerAPI === TriggerTypeAPI.FILE_UPLOAD_DETACH
                        ? "linear-gradient(270deg, lightcoral, red, darkred)"
                        : "linear-gradient(270deg, #1764d2, #236fd3, #2e78d4, #3a81d4, #478dd6, #5095d6, #5b9ed8, #65a9db, #6bb1e1)",
                backgroundSize: "400% 400%",
                animation: `${flow} 1s ease infinite`
            }}
        />
    );
}
